import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderFooter.vue?vue&type=template&id=17a31c8c&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-meal-builder-footer.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-meal-builder-footer.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMealBuilderFooter.vue?vue&type=style&index=0&id=17a31c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a31c8c",
  null
  
)

export default component.exports